import { IOrder } from 'Shared/Types/order';
import { client } from 'Service/axios';
import { IListResponse } from 'Shared/Types/api';
import { IRefusedOrderPostData, IRefusedOrderResponse } from 'Shared/Types/api';
const ORDER_URL = 'orders/';

class Order {
  getOrderList({ page, pageSize }: { page?: number; pageSize?: number }) {
    return client.get<IListResponse<IOrder[]>>(ORDER_URL, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  }

  getOrder(id: number) {
    return client.get<IOrder>(`${ORDER_URL}${id}`);
  }

  async getPreviousOrders(id: number): Promise<IOrder[] | undefined> {
    const response = await client.get(`${ORDER_URL}last_similar/${id}`);
    const data = response.data?.nearby_orders;
    return data;
  }

  refuseOrder(data: IRefusedOrderPostData) {
    return client.post<IRefusedOrderResponse>(`${ORDER_URL}refuse/`, data);
  }

  createOrder(data: IOrder) {
    return client.post(`${ORDER_URL}create/`, data);
  }
}

export default Order;
